import type { BrandSpecial } from '@iheartjane/data-access';
import type { SmartSortProduct } from '@iheartjane/dm-sdk';
import type { QualifyingStatusEnum } from '@iheartjane/types';
import { useCallback } from 'react';

import type { AlgoliaProduct } from '@jane/search/types';
/* eslint-disable-next-line no-restricted-imports */
import type { PendingCartProduct } from '@jane/shared/models';
import type { MenuProduct } from '@jane/shared/types';

import {
  filterProductsByWeight,
  shouldShowWeight,
} from './MenuBrandSpecialDetail.util';

interface UseWeightFilters {
  cartProducts: PendingCartProduct[];
  currentSpecial?: BrandSpecial;
  qualifyingStatus?: QualifyingStatusEnum;
}
export const useWeightFilters = ({
  cartProducts,
  currentSpecial,
  qualifyingStatus,
}: UseWeightFilters) => {
  const weightFilter = useCallback(
    (weight: string, product: MenuProduct | AlgoliaProduct) =>
      shouldShowWeight({
        currentSpecial,
        cartProducts,
        qualifyingStatus,
      })(weight, product),
    [currentSpecial, cartProducts, qualifyingStatus]
  );

  const additionalProductFilter = useCallback(
    (products: SmartSortProduct<AlgoliaProduct>[]) => {
      return filterProductsByWeight({
        cartProducts: cartProducts,
        currentSpecial,
        products,
        qualifyingStatus,
      });
    },
    [cartProducts, currentSpecial, qualifyingStatus]
  );

  return {
    additionalProductFilter,
    weightFilter,
  };
};
